import { useCallback, useContext, useMemo } from 'react';

import { ConnectionContext } from '@frontend/contexts';

import { UserInstruction } from '../types';

export const useProductScope = () => {
  const { products } = useContext(ConnectionContext);

  // useMemo to create a lookup map for better performance
  const instanceToProductMap = useMemo(() => {
    const map = new Map<string, string>();
    Object.values(products).forEach(product => {
      if (product.instances && product.scope_name) {
        product.instances.forEach(instance => {
          map.set(instance.id, product.scope_name);
        });
      }
    });
    return map;
  }, [products]);

  const getProductSku = useCallback(
    (userInstruction: UserInstruction) => {
      const productSkus = new Set<string>(userInstruction.product_sku || []);

      // Add product SKUs from instances using the optimized lookup
      userInstruction.instance_id?.forEach(instance_id => {
        const productSku = instanceToProductMap.get(instance_id);
        if (productSku) {
          productSkus.add(productSku);
        }
      });

      const skus = Array.from(productSkus);
      return skus.length > 0 ? skus : ['All'];
    },
    [instanceToProductMap]
  );

  return { getProductSku };
};
